export default "__VITE_ASSET__eqJOK72Y__"